module.exports = __webpack_public_path__ + "static/media/paula-barbosa.437a9e37.jpg";